import { useCallback } from 'react';
import * as XLSX from 'xlsx';
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";

export const ExcelExportDS =({data, fileName,...props})=> {
    const excelColumns = Object.keys(data[0]).map((key) => (
        <ExcelExportColumn key={key} field={key} title={key} />
    ));

    return (
        <ExcelExport data={data} fileName={fileName} {...props} >
            {excelColumns}
        </ExcelExport>
    );
}
export const exportToExcel = (gridApi,FileName) => {
 
    if (gridApi.current) {
      const exportColumns = gridApi.current.getColumnDefs();
      const rowData = [];
     // const columnWidths = []; // Array to store column widths
      gridApi.current.forEachNodeAfterFilterAndSort(node => {
        const row = {};
        exportColumns.forEach(column => {
          if(column.field!==undefined)
          {
            if (column.valueFormatter) {
              // Use the value formatter to get the formatted value
              row[column.headerName] = column.valueFormatter({ value: node.data[column.field] });
            } else {
              row[column.headerName] = node.data[column.field];
            }
          }
        });
        rowData.push(row);
      });
      const worksheet = XLSX.utils.json_to_sheet(rowData,
        [
          exportColumns.map(column => column.headerName),
        ]
      ); 
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook,FileName );
    }
  }

//since our ag-grid is licensed kindly use the directly use the below function to export grid as Excel  
export const exportToExcelUsingRef = (ref,fileName ) => {
  ref.current?.api.exportDataAsExcel({
    fileName,
    processCellCallback: (params) => {
      if (params.value && typeof params.value === 'object') {
        return JSON.stringify(params.value);
      }
      if (params.column && params.column.getColId() === 'newReturn') {
        const value = params.value;
        return value !== null && value !== undefined ? value / 100 : value;
    }
      return params.value;
    }
  });
};
// export const exportToExcelUsingRef = (ref, fileName) => {
//   ref.current?.api.exportDataAsExcel({
//     fileName,
//     processCellCallback: (params) => {
//       if (params.value && typeof params.value === 'object') {
//         return JSON.stringify(params.value);
//       }
//       if (params.column && params.column.getColId() === 'newReturn') {
//         const value = params.value;
//         return value !== null && value !== undefined ? value / 100 : value;
//       }
//       return params.value;
//     },
//     processRowGroupCallback: (params) => {
//       // Adjusts row groups for export to maintain the grid structure
//       return params.node.key || params.node.groupData;
//     },
//     processHeaderCallback: (params) => {
//       // Customize headers if needed
//       return params.column.getColId() === 'newReturn' ? 'New Return (%)' : params.column.getColDef().headerName;
//     },
//     sheetName: "LiquidityData", // Specify sheet name
//     exportMode: "xlsx", // Use "xlsx" for compatibility with Excel
//     // shouldRowBeSkipped: (params) => {
//     //   // Optionally skip pinned rows if they're not desired
//     //   return params.node.rowPinned;
//     // }
//   });
// };

// Modified export function to handle multiple sheets
export const exportToExcelUsingXlsx = (gridApis, sheetNames, fileName) => {
  const workbook = XLSX.utils.book_new();

  const exportGridDataToSheet = (gridApi, sheetName) => {
    const formattedData = [];

    // Process each node in the grid
    gridApi.forEachNodeAfterFilterAndSort((node) => {
      let rowData = {};

      if (node.group) {
        // Group header row with Strategy name and count
        rowData = {
          Strategy: `${node.key} (${node.allChildrenCount})`,
          Asset: '',
          CurrentPosition: '',
          Weight: '',
        };
      } else {
        const row = node.data;
        const redemptions = [...(row.QuickestRedemptions || []), ...(row.CheapestRedemptions || [])];
        rowData = {
          Strategy: `${node.data.StrategyName}`,
          Asset: row.AssetName,
          Portfolio: row.PortfolioAbbrev,
          CurrentPosition: row.MarketValue || 0, // Keep as number for formatting
          Weight: row.Weight || 0, // Keep as decimal for formatting
        };

        redemptions.forEach((redemption) => {
          const formattedDate = new Date(redemption.RedemptionDate).toLocaleDateString('en-US');
          rowData[formattedDate] = redemption.RedemptionAmount || 0; // Keep as number for formatting
        });
      }

      formattedData.push(rowData);
    });

    // Add pinned bottom row if present
    if (gridApi.getPinnedBottomRow(0)) {
      const pinnedBottomRows = gridApi.pinnedRowModel.pinnedBottomRows;

      pinnedBottomRows.forEach((pinnedRow) => {
        const rowData = pinnedRow.data;
        const redemptions = [...(rowData.QuickestRedemptions || []), ...(rowData.CheapestRedemptions || [])];

        const redemptionData = redemptions.reduce((acc, item) => {
          const exactDateString = item.RedemptionDate; // Use the exact date string from rowData
          const formattedDate = new Date(item.RedemptionDate).toLocaleDateString('en-US');
          acc[formattedDate] = item.RedemptionAmount || 0; // Keep as number
          return acc;
        }, {});

        const pinnedRowData = {
          Strategy: rowData.StrategyName[0],
          CurrentPosition: rowData.MarketValue || 0,
          Weight: rowData.Weight || 0,
          ...redemptionData,
        };

        formattedData.push(pinnedRowData);
      });
    }

    // Convert data to worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Apply formatting
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let row = range.s.r; row <= range.e.r; row++) {
      // Format CurrentPosition column (assume column C)
      const currentPositionCell = `D${row + 1}`;
      if (ws[currentPositionCell]) {
        if (ws[currentPositionCell].v === 0) {
          ws[currentPositionCell].v = ''; // Blank out zero values
        } else if (typeof ws[currentPositionCell].v === 'number') {
          ws[currentPositionCell].z = '$#,##0'; // Currency format
        }
      }

      // Format Weight column (assume column D)
      const weightCell = `E${row + 1}`;
      if (ws[weightCell]) {
        if (ws[weightCell].v === 0) {
          ws[weightCell].v = ''; // Blank out zero values
        } else if (typeof ws[weightCell].v === 'number') {
          ws[weightCell].z = '0.00%'; // Percentage format
        }
      }

      // Format all columns after D as currency
      for (let col = XLSX.utils.decode_col("F"); col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (ws[cellAddress]) {
          if (ws[cellAddress].v === 0) {
            ws[cellAddress].v = ''; // Blank out zero values
          } else if (typeof ws[cellAddress].v === 'number') {
            ws[cellAddress].z = '$#,##0'; // Currency format
          }
        }
      }
    }

    // Append sheet to workbook
    XLSX.utils.book_append_sheet(workbook, ws, sheetName);
  };

  // Export data for each grid in gridApis array to corresponding sheets
  gridApis.forEach((gridApi, index) => {
    exportGridDataToSheet(gridApi, sheetNames[index]);
  });

  // Write the workbook to an Excel file
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
export const excelStyles= [
  {
      id: 'numberType',
      numberFormat: {
          format: '0',
      },
  },
  {
      id: 'currencyFormat',
      numberFormat: {
          format: '$ #,##0.00',
      },
  },
  {
      id: 'negativeInBrackets',
      numberFormat: {
          format: '$[blue] #,##0;$ [red](#,##0)',
      },
  },
  {
      id: 'booleanType',
      dataType: 'Boolean',
  },
  {
      id: 'stringType',
      dataType: 'String',
  },
  {
      id: 'dateType',
      dataType: 'DateTime',
      numberFormat: {
        format: 'MM-DD-YYYY',
    },
  },
  {
    id: 'percentageFormat',
      numberFormat: {
          format: '0.00"%"',
      },
      alignment: {
          horizontal: 'Right',
      },
  }
]